<ng-template #iconWarn>
  <i class="ico-cancel light-color-warning"></i>
</ng-template>
<ng-template #noFeatureInfo>
  <div class="pnl-feature">
    <i class="ico-exclaim-1 light-color-info" aria-hidden="true"></i>
    <span i18n="@@pnlInformationUnavailable">Information unavailable</span>
  </div>
</ng-template>
@if (
  {
    results: searchService.searches[ServiceType.Parking].results | async,
    isvalid: searchService.searches[ServiceType.Parking].isValid | async,
    messages: searchService.searches[ServiceType.Parking].messages | async,
    listViewToggle: searchService.searches[ServiceType.Parking].listViewToggle | async
  };
  as data
) {
  <h2 class="visuallyhidden" i18n="@@parking_searchCriteria">Search Criteria</h2>
  <div class="background-container-background">
    <app-validate-errors [messages]="data.messages"></app-validate-errors>
    <a href="#parking" (click)="skipToResultContent()" class="sr-only sr-only-focusable"
      >Skip to Result Content</a
    >
    <app-invoked-user></app-invoked-user>
    <app-search-toggle [serviceType]="ServiceType.Parking">
      <app-parking-search></app-parking-search>
      <div class="flex-row-container flex-row-container--right">
        <button
          type="button"
          (click)="performSearch()"
          [disabled]="!data.isvalid"
          appButton="large-search"
          type="button"
          i18n="@@parking_search"
        >
          Search
        </button>
      </div>
    </app-search-toggle>
  </div>
  @if (!searchService.search_loading) {
    <app-risk-alerts
      [countryCode]="searchService.searches[ServiceType.Parking].locationCode?.countryCode"
    ></app-risk-alerts>
  }
  @if (flightSearchParams.parkingFromFlightSearchPerformed) {
    <button
      appButton="small"
      class="back-to-button"
      routerLink="/results/flights"
      i18n="@@backToFlightsTrainlineEu"
      id="parking-button-back-to-flights"
    >
      <i class="ico-flight" aria-hidden="true"></i>
      Back to Flights
    </button>
  }
  <div id="parking" class="pnl-results-container">
    @if (data.results && data.results.length === 0) {
      <app-no-results></app-no-results>
    }
    @switch (data.listViewToggle) {
      @case (null) {
        <div>
          <app-parking-list-view [canOverride]="canOverride" [data]="data"></app-parking-list-view>
        </div>
      }
      @default {
        <div>
          <app-parking-map-view [mapData]="data.listViewToggle"> </app-parking-map-view>
        </div>
      }
    }
  </div>
}
<app-parking-loading-screen [animated]="false"></app-parking-loading-screen>
